<div class="carousel-container">
  <img class="gear2" src="assets/images/gear2.svg" alt="" />
  <div class="carousel-images">
    @if (currentIndex === 0) {
      <div class="first-item">
        <img src="assets/images/gear1.svg" alt="" />
        <div class="first-item-content">
          <p class="nada">NADA</p>
          <p class="group-id">{{ GroupName }}</p>
          <p class="group">Group</p>
        </div>
      </div>
    } @else {
      <div class="second-item">
        <img src="assets/images/hand-shake.svg" alt="" />
      </div>
    }
  </div>
  <div class="carousel-indicators">
    <div
      class="indicator"
      [class.active]="0 === currentIndex"
      (click)="goToImage(0)"
    ></div>
    <div
      class="indicator"
      [class.active]="1 === currentIndex"
      (click)="goToImage(1)"
    ></div>
  </div>
</div>
